import { StorageService } from './';
import store from '../store';
import moment from 'moment';

const apiBaseUrl = () => {
  return import.meta.env.VITE_APP_API_URL;
};

const appBaseUrl = () => {
  return import.meta.env.VITE_APP_BASE_URL;
};

const appName = () => {
  return import.meta.env.VITE_APP_NAME || '';
};

const appVersion = () => {
  return import.meta.env.VITE_APP_VERSION || '';
};

const mollieDashboardPaymentLink = () => {
  return import.meta.env.VITE_APP_MOLLIE_DASHBOARD_PAYMENT_URL || '';
};

const authorizationToken = () => {
  let _auth = StorageService.getObject('authUser');
  let _token = null;
  try {
    _token = _auth['token'];
  } catch {
    _token = null;
  }

  return 'Bearer ' + _token;
};

const authUser = () => {
  let _auth = StorageService.getObject('authUser');

  return _auth;
};

const IsLoginStatus = () => {
  const state = store.getState();
  if (state.auth != null && state.auth.user != null) {
    let status = false;
    if (state.auth.user) {
      status = true;
    }

    return status;
  }
  return false;
};

const shortenAddress = (_walletAddress) => {
  if (
    _walletAddress === undefined ||
    _walletAddress == null ||
    _walletAddress === ''
  ) {
    return 'NA';
  }
  return _walletAddress.slice(0, 5) + '...' + _walletAddress.slice(-4);
};

const imageUrl = () => {
  return import.meta.env.VITE_APP_IMAGE_URL;
};

const dateFormat = (_date, _type) => {
  let date = null;
  if (_type) {
    date = moment(_date).format('DD MMM YYYY HH:mm');
  } else {
    date = moment(_date).format('DD MMM YYYY');
  }
  return date;
};

const formatDate = (_date, _type) => {
  let date = moment(_date);
  if (_type === 'dmyt') {
    return date.format('DD MMM YYYY HH:mm');
  } else if (_type === 'dmy') {
    return date.format('DD MMM YYYY');
  } else if (_type === 'my') {
    return date.format('MMM YYYY');
  } else if (_type === 'm') {
    return date.format('MMM');
  } else if (_type === 'y') {
    return date.format('YYYY');
  }
  return date.format('DD MMM YYYY');
};

function toTitleCase(word) {
  // Check if the input is a string and not empty
  if (typeof word !== 'string' || word.length === 0) {
    return word;
  }

  // Capitalize the first letter and concatenate with the rest of the word
  return word.charAt(0).toUpperCase() + word.slice(1);
}

export {
  apiBaseUrl,
  appBaseUrl,
  appName,
  appVersion,
  authorizationToken,
  authUser,
  IsLoginStatus,
  shortenAddress,
  imageUrl,
  dateFormat,
  toTitleCase,
  formatDate,
  mollieDashboardPaymentLink,
};
